var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h6',[_vm._v(_vm._s(_vm.title))]),_c('div',[_vm._v("I washed ___.")]),_vm._v(" my hands for "),_c('TryAgainButton',{attrs:{"renew":_vm.renew}}),_c('Achievement',{attrs:{"rightness":_vm.correct,"total":_vm.total}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }